__turbopack_context__.v({
  "circle": "style-module-scss-module__zUjZqW__circle",
  "content": "style-module-scss-module__zUjZqW__content",
  "curvedContainer": "style-module-scss-module__zUjZqW__curvedContainer",
  "curvedText": "style-module-scss-module__zUjZqW__curvedText",
  "curvedWrapper": "style-module-scss-module__zUjZqW__curvedWrapper",
  "formSection": "style-module-scss-module__zUjZqW__formSection",
  "wrapper": "style-module-scss-module__zUjZqW__wrapper",
});
